import { HeadingPriority } from "atoms/constants/heading-priority";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import NotificationDotIcon from "atoms/icons/notification-dot-icon";
import Heading from "atoms/typography/heading";
import NotebookRecord from "models/view-models/notebook-record";
import useNotebookSidebar from "pages/notebooks/sidebar/use-notebook-sidebar";
import React from "react";
import { Link } from "react-router-dom";

interface RecentNotebooksListItemProps {
    notebook: NotebookRecord;
    iconType?: Icons;
}

const CSS_BASE_CLASS = "c-recent-notebooks-list-item";

const RecentNotebooksListItem = (props: RecentNotebooksListItemProps) => {
    const { notebook, iconType = Icons.Notebook } = props;

    const { notebookRoute } = useNotebookSidebar();

    return (
        <div className={CSS_BASE_CLASS}>
            <header className={`${CSS_BASE_CLASS}__header`}>
                <div className={`${CSS_BASE_CLASS}__iconWrapper`}>
                    <Icon type={iconType} />
                    {notebook.isNewlyShared && (
                        <NotificationDotIcon pulse={true} />
                    )}
                </div>
                <div className={`${CSS_BASE_CLASS}__headingWrapper`}>
                    <Heading
                        cssClassName={`${CSS_BASE_CLASS}__heading`}
                        priority={HeadingPriority.Five}>
                        <Link
                            className={`${CSS_BASE_CLASS}__link`}
                            to={notebookRoute(notebook.id ?? 0)}>
                            {notebook.name}
                        </Link>
                    </Heading>
                </div>
            </header>
        </div>
    );
};

export default RecentNotebooksListItem;
